/***********MultiStep*************/
$(document).ready(function() {

    // Custom method to validate username
    $.validator.addMethod("usernameRegex", function(value, element) {
        return this.optional(element) || /^[a-zA-Z0-9]*$/i.test(value);
    }, "Username must contain only letters, numbers");

    $(".next, .submit-btn").click(function(event) {
       // alert('sss');
        jQuery.getJSON('/cart.js', function(cart) {
            var cartIems = cart.items;
            if (cartIems.length > 0) {

                var selectVal = $("#hear_about_us").val();
                if (selectVal == 'Please select one') {
                    alert('please select one option');
                    return false;
                }
                if ($('input#additional_hear').css('display') == 'block') {
                    if (!$('input#additional_hear').val()) {
                        alert('All fields are required');
                        return false;
                    }
                }

                $("legend.alert").css("display", "none");
                event.preventDefault();
                var form = $("#myform");
                form.validate({
                    errorElement: 'span',
                    errorClass: 'help-block',
                    highlight: function(element, errorClass, validClass) {
                        $(element).closest('.form-group').addClass("has-error");
                    },
                    unhighlight: function(element, errorClass, validClass) {
                        $(element).closest('.form-group').removeClass("has-error");
                    },
                    rules: {
                        username: {
                            required: true,
                            usernameRegex: true,
                        },
                        password: {
                            required: true,
                        },
                        conf_password: {
                            required: true,
                            equalTo: '#password',
                        },
                        company: {
                            required: true,
                        },
                        url: {
                            required: true,
                        },
                        name: {
                            required: true,
                        },
                        email: {
                            required: true,
                            minlength: 5,
                        },
                        first_name: {
                            required: true,
                        },
                        phone_number: {
                            required: true,
                        },
                        mailing_add: {
                            required: true,
                        },
                        dob: {
                            required: true,
                        },
                        city: {
                            required: true,
                        },
                        state: {
                            required: true,
                        },
                        zipcode: {
                            required: true,
                        },
                        hear_about_us: {
                            required: true,
                        },
                        country: {
                            required: true,
                        },
                        r_first_name: {
                            required: true,
                            minlength: 6,
                        },
                        r_last_name: {
                            required: true,
                        },
                        r_email: {
                            required: true,

                            minlength: 6,
                        },
                        r_address: {
                            required: true,

                        },
                        r_city: {
                            required: true,

                        },
                        r_state: {
                            required: true,

                        },
                        r_zipcode: {
                            required: true,

                        },
                    },
                    messages: {
                        username: {
                            required: "Please check term and condition",
                        },
                        password: {
                            required: "Password required",
                        },
                        conf_password: {
                            required: "Confirm Password required",
                            equalTo: "Password don't match",
                        },
                        name: {
                            required: "Name required",
                        },
                        email: {
                            required: "Email required",
                        },
                        first_name: {
                            required: "User's First Name required",
                        },
                        phone_number: {
                            required: "Phone number required",
                        },
                        mailing_add: {
                            required: "Mailing address required",
                        },
                        dob: {
                            required: "Date of Birth required",
                        },
                        city: {
                            required: "User's City required",
                        },
                        state: {
                            required: "User's State required",
                        },
                        zipcode: {
                            required: "User's Zip Code required",
                        },
                        hear_about_us: {
                            required: "Please select one option",
                        },
                        country: {
                            required: "User's Country required",
                        },
                        r_first_name: {
                            required: "Recipient's First Name required",
                        },
                        r_last_name: {
                            required: "Recipient's Last Name required",
                        },
                        r_email: {
                            required: "Recipient's Email required",
                        },
                        r_address: {
                            required: "Recipient's Address required",
                        },
                        r_city: {
                            required: "Recipient's City required",
                        },
                        r_state: {
                            required: "Recipient's State required",
                        },
                        r_zipcode: {
                            required: "Recipient's Zip Code required",
                        },
                    }
                });
                if (form.valid() === true) {
                    /****** Set Attr Value *********/
                    var serializeData = $('#myform').serialize();
                    //console.log($('input[name=first_name]').val());
                    var fName = $('input[name=first_name]').val();
                    var lName = $('input[name=last_name]').val();
                    var useremaIL = $('input[name=email]').val();
                    var user_addresS = $('input[name=mailing_add]').val();
                    var phonenumBER = $('input[name=phone_number]').val();
                    var birthdAY = $('input[name=dob]').val();

                    var rFName = $('input[name=r_first_name]').val();
                    var rLName = $('input[name=r_last_name]').val();
                    var rEmail = $('input[name=r_email]').val();
                    var raddresS = $('input[name=r_address]').val();
                    var emailNoty = $('input[name=datepicker]').val();
                    var bottalDelv = $('input[name=datepicker1]').val();


                    $('#reci_fname').text(rFName);
                    $('#reci_lname').text(rLName);
                    $('#reci_email').text(rEmail);
                    $('#reci_address').text(raddresS);
                    $('#reci_email_notift').text(emailNoty);
                    $('#reci_email_bottal_delvry').text(bottalDelv);
                    $('#notification_date').text(emailNoty);

                    $('#user_namE').text(fName + ' ' + lName);
                    $('#user_emaiL').text(useremaIL);
                    $('#user_addres').text(user_addresS);
                    $('#phone_num').text(phonenumBER);
                    $('#bithdate').text(birthdAY);



                    jQuery.getJSON('/cart.js', function(cart) {
                        var cartIems = cart.items;
                        //console.log(cart)
                        if (cartIems.length > 0) {
                            //                 var subTotal = cart.items_subtotal_price-4900;
                            var total_price = cart.total_price;
                            if (cartIems.length >= 2) {
                                var subTotal = cart.items_subtotal_price - 4900;
                            } else {
                                if (cartIems.length <= 1) {
                                    $('div#discount_tc').hide();
                                }
                                var subTotal = cart.items_subtotal_price;
                            }
                            $('#total').text(Shopify.formatMoney(subTotal));
                            $('#sub_total').text(Shopify.formatMoney(total_price));
                            $('#sub_total1').text(Shopify.formatMoney(total_price));

                        }
                    });



                    var productData = JSON.parse(localStorage.getItem("products_key"));
                    //$('#brand_name').text(productData.product_name);
                    $('#brand_name').text('product name');

                    /******	SubmitUser	**********/
                    jQuery(".submit_request").click(function() {
                        var checkLoginUser = localStorage.getItem("loginId");
                        if (checkLoginUser == 'notLogin') {
                            addCustomer();
                        }
                    });
//                     jQuery(".btn.btn-primary.nextUser.submit-btn").click(function() {
//                         var checkLoginUser = localStorage.getItem("loginId");
//                         if (checkLoginUser == 'notLogin') {
//                             addCustomer();
//                         }
//                     });


                    function addCustomer() {
                        setTimeout(function() {
                            jQuery('#loadingmessage').show();
                            var url = 'https://cybersify.tech/smwsa/swapp/submitform';
                            jQuery.ajax({
                                type: "POST",
                                url: url,
                                data: $('#myform').serialize(),
                                success: function(results) {
                                    setTimeout(function() {
                                        jQuery('#loadingmessage').hide();
                                        //var responce = JSON.parse(results.responseText);
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'You successfully registered on SMWSA',
                                            showConfirmButton: false,
                                            timer: 1500
                                        });
                                    }, 2000);
                                    if ($('#personal_information1').is(":visible")) {
                                        current_fs = $('#personal_information1');
                                        next_fs = $('#conf_your_info1');
                                        jQuery('li.sixth').addClass('active');
                                    } else if ($('#conf_your_info1').is(":visible")) {
                                        current_fs = $('#conf_your_info1');
                                        next_fs = $('#conf_your_info1');
                                        jQuery('li.sixth').addClass('active');
                                    }
                                    next_fs.show();
                                    current_fs.hide();
                                },
                                error: function(results) {
                                    setTimeout(function() {
                                        jQuery('#loadingmessage').hide();
                                        var responce = JSON.parse(results.responseText);
                                        if (responce.message == 'Customer created successfully.') {
                                            Swal.fire({
                                                icon: 'success',
                                                title: responce.message,
                                                showConfirmButton: false,
                                                timer: 1500
                                            });
                                            if ($('#personal_information1').is(":visible")) {
                                                current_fs = $('#personal_information1');
                                                next_fs = $('#conf_your_info1');
                                                jQuery('li.sixth').addClass('active');
                                            } else if ($('#conf_your_info1').is(":visible")) {
                                                current_fs = $('#conf_your_info1');
                                                next_fs = $('#conf_your_info1');
                                                jQuery('li.sixth').addClass('active');
                                            }
                                            next_fs.show();
                                            current_fs.hide();
                                        } else {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Oops...',
                                                text: responce.message
                                            });
                                        }
                                    }, 2000);
                                }
                            });
                        }, 2000);
                    }


                    //           jQuery(".btn.btn-primary.nextUser.submit-btn").click(function(){
                    //             jQuery('#loadingmessage').show();
                    //           });

                    /****** Start Update Basket ***********/
                    setTimeout(function() {
                        jQuery.getJSON('/cart.js', function(cart) {
                            console.log(cart.token);
                            var cartToken = cart.token;
                            var rucringUrl = 'https://recurringcheckout.com/s/smwsa-dev-v1/checkout/recurring/' + cartToken + '?shop_url=smwsa-dev-v1.myshopify.com';
                            jQuery('a.cart-count.contain-count span.bag-count').text(cart.item_count);
                            setTimeout(function() {
                                jQuery('#myform').attr('action', 'https://recurringcheckout.com/s/smwsa-dev-v1/checkout/recurring/' + cartToken + '?shop_url=smwsa-dev-v1.myshopify.com');
                                if (cart.item_count > 0) {
                                    console.log(cart.item_count);
                                    //$(".loader").css("display", "none");	
                                    //$(".mycheckouyC").css("display", "block");
                                } else {
                                    $("legend.alert").css("display", "block");
                                }
                            }, 5000);
                        });
                    }, 1000);
                    /****** End Update Basket ***********/

                    var ifName = $('input[name=first_name]').val();
                    var ifEmail = $('input[name=email]').val();
                    var ifPassword = $('input[name=password]').val();
                    var ifConPassword = $('input[name=conf_password]').val();
                    var ifaddress = $('input[name=address]').val();
                    var ifcity = $('input[name=city]').val();
                    var ifstate = $('input[name=state]').val();
                    var ifzipcode = $('input[name=zipcode]').val();
                    var ifvariationsId = $('input[name=shopify_variations_id]').val();
                    var proprizE = $('#pro_price').val();
                    //var productIdD = $('input[name=shopify_product_id]').val();
                    //alert(productIdD);
                    var productData = JSON.parse(localStorage.getItem("products_key"));
                    //console.log('variation_id ' + productData.variation_id);

                    if (ifName != '' && ifEmail != '' && ifPassword != '' && ifConPassword != '' && ifaddress != '' && ifcity != '' && ifstate != '' && ifzipcode != '' && ifvariationsId != '') {
                        jQuery.post('/cart/add.js', {
                            quantity: 1,
                            //id: ifvariationsId,
                            //id: productData.variation_id,
                            id: 31735745151020,
                            properties: {
                                'frequency_num': '1',
                                'frequency_type': '1',
                                'frequency_type_text': 'Year(s)',
                                'group_id': '124590',
                                '_ro_discount_percentage': '0',
                                '_ro_unformatted_price': 99
                            }
                        });
                    }
                    //           });
                    /************** End Add To Cart Product *******************/


                    /******* End Set Attr Value ************/
                    if ($('#account_information1').is(":visible")) {
                        current_fs = $('#account_information1');
                        next_fs = $('#membership_product1');
                        jQuery('li.second').addClass('active');
                    } else if ($('#membership_product1').is(":visible")) {
                        current_fs = $('#membership_product1');
                        next_fs = $('#personal_information1');
                        jQuery('li.fouth').addClass('active');
                    }
                    var checkLoginUser = localStorage.getItem("loginId");
                    if (checkLoginUser != 'notLogin') {
                        if ($('#personal_information1').is(":visible")) {
                            current_fs = $('#personal_information1');
                            next_fs = $('#conf_your_info1');
                            jQuery('li.sixth').addClass('active');
                        } else if ($('#conf_your_info1').is(":visible")) {
                            current_fs = $('#conf_your_info1');
                            next_fs = $('#conf_your_info1');
                            jQuery('li.sixth').addClass('active');
                        }
                    }
                    next_fs.show();
                    current_fs.hide();
                }
            } else {
                //alert('cart is empty');
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Cart is empty...!!'
                });
            }
        });


    });

    $('#previous').click(function() {
        if ($('#account_information1').is(":visible")) {
            current_fs = $('#account_information1');
            next_fs = $('#membership_product1');
        } else if ($('#membership_product1').is(":visible")) {
            current_fs = $('#membership_product1');
            next_fs = $('#personal_information1');
        } else if ($('#company_information').is(":visible")) {
            current_fs = $('#company_information');
            next_fs = $('#personal_information1');
        } else if ($('#personal_information1').is(":visible")) {
            current_fs = $('#personal_information1');
            next_fs = $('#company_information');
        } else if ($('#user_account').is(":visible")) {
            current_fs = $('#user_account');
            next_fs = $('#personal_information1');
        } else if ($('#conf_your_info1').is(":visible")) {
            current_fs = $('#conf_your_info1');
            next_fs = $('#user_account');
        }
        next_fs.show();
        current_fs.hide();
    });
});
/***********EndMultiStep*************/